/*
 * Tutorial Form Messages
 *
 * This contains all the text for the Tutorial Form component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.SetupPage.components.Tutorials.components.TutorialForm';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Tutorial',
  },
  createButton: {
    id: `${scope}.createButton`,
    defaultMessage: 'Create new field',
  },
  codeLabel: {
    id: `${scope}.codeLabel`,
    defaultMessage: 'Code',
  },
  typeLabel: {
    id: `${scope}.typeLabel`,
    defaultMessage: 'Type',
  },
  cohortLabel: {
    id: `${scope}.cohortLabel`,
    defaultMessage: 'Cohort',
  },
  titleEnLabel: {
    id: `${scope}.titleEnLabel`,
    defaultMessage: 'Title EN',
  },
  titleDeLabel: {
    id: `${scope}.titleDeLabel`,
    defaultMessage: 'Title DE',
  },
  descriptionEnLabel: {
    id: `${scope}.descriptionEnLabel`,
    defaultMessage: 'Description EN',
  },
  descriptionDeLabel: {
    id: `${scope}.descriptionDeLabel`,
    defaultMessage: 'Description DE',
  },
  shownToUsers: {
    id: `${scope}.shownToUsers`,
    defaultMessage: '(shown to users)',
  },
  editTooltip: {
    id: `${scope}.editTooltip`,
    defaultMessage: 'Edit',
  },
});
